export { default } from "./Receipt.page";
